// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zVaXj0_xMR4lEaBpIhpu{text-align:center;color:var(--content-primary-tertiary);background-color:var(--background-neutral-subtle);border-radius:8px;padding:12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `zVaXj0_xMR4lEaBpIhpu`
};
export default ___CSS_LOADER_EXPORT___;
